export class TypedSearchParams<T> {
  params: URLSearchParams;

  constructor(init?: string) {
    this.params = new URLSearchParams(init);
  }

  append(name: keyof T, value: string) {
    this.params.append(name as string, value);
  }

  delete(name: keyof T) {
    this.params.delete(name as string);
  }

  entries() {
    return this.params.entries();
  }

  forEach(callback) {
    return this.params.forEach(callback);
  }

  get<K extends keyof T>(name: K) {
    return this.params.get(name as string) as T[K];
  }

  getAll<K extends keyof T>(name: K) {
    return this.params.getAll(name as string) as T[K][];
  }

  has(name: keyof T) {
    return this.params.has(name as string);
  }

  keys() {
    return this.params.keys();
  }

  set(name: keyof T, value: string) {
    this.params.set(name as string, value);
  }

  get size() {
    return this.params.size;
  }

  sort() {
    this.params.sort();
  }

  toString() {
    return this.params.toString();
  }

  values() {
    return this.params.values();
  }
}
